import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class UnitWaterModel extends BaseModel {

    constructor() {
        super({
            name: "unit_water",
            tableName: 'unit_water',
            label: "Unit thông số nước",
            display_key: 'name',
            default_order: { key: 'ordinal', direction: 'asc' }
            },
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                class: "center",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: {
                name: 'id',
                type: "Uuid",
                label: 'ID',
                primaryKey: true,
                display: false
            },
            history_done_id: {
                name: 'history_done_id',
                type: "Uuid",
                label: 'ID',
                display: false
            },
            water_parameters_value_id: {
                name: 'water_parameters_value_id',
                type: "Uuid",
                label: 'ID',
                display: false
            },
            deleted_at: {
                name: 'deleted_at',
                type: "DateTime",
                label: 'Ngày xóa',
                display: false
            },
            },
        )
    }

}